// Math.jsx — React wrapper that auto-typesets LaTeX via MathJax.
// MathJax is loaded once globally from CDN in frontend/index.html; we just
// poll for `window.MathJax.typesetPromise` and feed it the ref after each
// content change. dangerouslySetInnerHTML so React leaves the MathJax-
// generated DOM alone across re-renders.
import React from 'react';

export function TeX({ children, as = "span", className, style }) {
  const ref = React.useRef(null);
  const Tag = as;
  const content = React.Children.toArray(children).join("");

  React.useEffect(() => {
    const el = ref.current;
    if (!el) return;
    let cancelled = false;

    const typeset = () => {
      if (cancelled) return;
      const mj = window.MathJax;
      if (!mj || typeof mj.typesetPromise !== "function") {
        setTimeout(typeset, 150);
        return;
      }
      const ready = mj.startup?.promise || Promise.resolve();
      ready.then(() => {
        if (cancelled) return;
        mj.typesetPromise([el]).catch(() => {});
      });
    };
    typeset();
    return () => { cancelled = true; };
  }, [content]);

  return (
    <Tag
      ref={ref}
      className={className}
      style={style}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
}

export function typesetMath(el) {
  if (!el || !window.MathJax) return;
  const mj = window.MathJax;
  if (typeof mj.typesetPromise === "function") {
    mj.typesetPromise([el]).catch(() => {});
  } else if (typeof mj.typeset === "function") {
    try { mj.typeset([el]); } catch (e) { /* noop */ }
  }
}
